import React, { useContext } from 'react';
import { DirectionalHint, Link } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { defaultUserGovernanceConfig } from '@bingads-webui-campaign-react/multi-step-teaching-bubble';

const getStyle = () => ({
  link: {
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    '&:hover': {
      color: 'rgb(255, 255, 255)',
      textDecoration: 'underline',
    },
    '&:focus': {
      color: 'rgb(255, 255, 255)',
      textDecoration: 'underline',
    },
  },
});

const ChurnModelNotificationContent = () => {
  const i18n = useContext(I18nContext);
  const clarityTextTemplate = i18n.getString(_TL_('Join one of our experienced Microsoft Advertising Experts for a FREE consultation by scheduling an appointment below or calling us at  {{phoneNumber}}877-635-3561{{/phoneNumber}}.'));
  const classes = useDefaultStyles(getStyle);

  const content1 = (
    <ReactTemplate
      model={{
        phoneNumber: text => (
          <Link
            className={classes.link}
            href="tel:8776353561"
            aria-label={text}
            inline
          >
            {text}
          </Link>
        ),
      }}
      template={clarityTextTemplate}
    />
  );
  return (
    <div className="churn-model-teaching-bubble">
      <p>{content1}</p>
      <p>
        {i18n.getString(_TL_('Optimize your campaign during the consultation and we will issue you a $250 USD ad credit.'))}
      </p>
    </div>
  );
};

export const churnModelCouponNotificationFeatureName = 'churn-model-coupon-notification-teaching-bubble';
export const ChurnModelCouponNotificationTeachingBubbleUIConfig =
{
  featureName: churnModelCouponNotificationFeatureName,
  userGovernanceConfig: defaultUserGovernanceConfig,
  steps: [
    {
      title: _TL_('Your ad credit awaits!'),
      content: (<ChurnModelNotificationContent />),
      primaryButtonText: _TL_('Schedule now'),
      // first condition from coupon, the second condition ensured selector billing if no overflow
      targetElement: 'div#billing>button.side-navigation-item-button,div[data-overflow-item][data-overflow-group]:not([data-overflowing]) button#billing, button.side-navigation-more-button',
      directionalHint: DirectionalHint.rightCenter,
      onNext: () => {
        window.open('https://outlook.office365.com/book/MicrosoftAdvertisingNorthAmericaEnglish@bookings.microsoft.com/s/oGpRHHqz5EKtN3pF_Dfn9w2', '_blank');
      },
      className: 'churn-target-notification-teaching-bubble',
    },
  ],
};
